<template>
  <span :class="['pill', variant]">
    <span class="dot" aria-hidden="true" :style="dotStyle" />
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    variant: "high" | "med" | "low" | "live" | "violet" | "neutral";
    /** When variant=live, pass an explicit color for the pulsing dot.
     *  Use 'closed' to render a muted dot (closed sprints). */
    state?: "active" | "closed" | undefined;
  }>(),
  { state: "active" },
);

const dotStyle = computed(() => {
  if (props.variant === "live" && props.state === "closed") {
    return { background: "var(--muted-2)", animation: "none" };
  }
  return undefined;
});
</script>
